import { createFileRoute } from "@tanstack/react-router"
import VerifyEmail from "@/pages/account/verify-email"

type VerifyEmailSearch = {
  token?: string
}

export const Route = createFileRoute("/$countryCode/account/verify-email")({
  validateSearch: (search: Record<string, unknown>): VerifyEmailSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Verify email | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: VerifyEmail,
})
